import React from "react";
import Header from "../Coman/Header";
import LoginBox from "./LoginBox";

function Login() {
  return (
    <div>
      <div id="main-wrapper" className="show">
        {/* <Header /> */}
        <LoginBox />
      </div>
    </div>
  );
}

export default Login;
